import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import LandingClone from './pages/LandingClone';
import LandingOptimized from './pages/LandingOptimized';
import { FiLayout, FiTrendingUp } from 'react-icons/fi';

const NavWrapper = ({ children }) => {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <div className="relative">
      {/* Version Switcher - Only visible for dev/preview purposes */}
      <div className="fixed top-4 right-4 z-50 bg-white/90 backdrop-blur-md shadow-lg border border-gray-200 rounded-full p-1.5 flex gap-1 transform scale-90 sm:scale-100 transition-all hover:opacity-100 opacity-50 hover:scale-105">
        <Link 
          to="/" 
          className={`px-4 py-2 rounded-full text-sm font-medium transition-all flex items-center gap-2 ${location.pathname === '/' ? 'bg-gray-900 text-white shadow-md' : 'text-gray-600 hover:bg-gray-100'}`}
        >
          <FiLayout /> V1: Clean
        </Link>
        <Link 
          to="/optimized" 
          className={`px-4 py-2 rounded-full text-sm font-medium transition-all flex items-center gap-2 ${location.pathname === '/optimized' ? 'bg-indigo-600 text-white shadow-md' : 'text-gray-600 hover:bg-gray-100'}`}
        >
          <FiTrendingUp /> V2: Optimized
        </Link>
      </div>
      {children}
    </div>
  );
};

function App() {
  return (
    <Router>
      <NavWrapper>
        <Routes>
          <Route path="/" element={<LandingClone />} />
          <Route path="/optimized" element={<LandingOptimized />} />
        </Routes>
      </NavWrapper>
    </Router>
  );
}

export default App;